import { Badge, Radio } from '@ksyos/design-system';
import {
    type OsasCloudPatExaminationCustomControlData,
    OsasCloudPatExaminationStatus,
} from '@common/validation/customControls/osas/osasCloudPatExaminationSchema';
import { useProcessActivityEditContext } from '@frontend/utils';
import { AssetThumbnails } from '../../processActivityAssets/ProcessActivityAssetsRead';
import { RadioGroupFormGroup, TextAreaFormGroup } from '../../processActivityFormGroupFields';

export function OsasCloudPatExaminationEdit(): JSX.Element {
    const { data } = useProcessActivityEditContext<OsasCloudPatExaminationCustomControlData>();

    return (
        <>
            <AssetThumbnails
                assets={data.assets}
                label="Bijlage"
            />

            <RadioGroupFormGroup
                fieldKey="status"
                label="Slaaponderzoek"
                value={data.status ?? undefined}
            >
                <Radio
                    key="failed"
                    label={
                        <Badge
                            color="red"
                            text="Mislukt"
                        />
                    }
                    value={OsasCloudPatExaminationStatus.Mislukt}
                />

                <Radio
                    key="success"
                    label={
                        <Badge
                            color="green"
                            text="Successvol"
                        />
                    }
                    value={OsasCloudPatExaminationStatus.Successvol}
                />
            </RadioGroupFormGroup>

            <TextAreaFormGroup
                fieldKey="remark"
                label="Toelichting"
                value={data.remark}
            />
        </>
    );
}
